import { z } from 'zod';

export const clientBasicInfoSchema = z.object({
  full_name: z.string().min(1, "Name is required").max(100),
  email: z.string().email("Invalid email").max(255),
  phone: z.string().optional(),
  address: z.object({
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().optional(),
    zip: z.string().optional(),
  }).optional(),
  client_status: z.enum(['active', 'inactive', 'archived']),
  preferred_contact_method: z.enum(['email', 'phone', 'text']).optional().nullable(),
});

export const clientTaxInfoSchema = z.object({
  tax_year: z.number().min(2000).max(2100),
  filing_status: z.string().optional().nullable(),
  ssn_last_4: z.string().max(4).optional().nullable(),
  previous_year_agi: z.number().optional().nullable(),
  dependents: z.array(z.object({
    name: z.string(),
    age: z.number().optional(),
    relationship: z.string().optional(),
  })).optional(),
});

export type ClientBasicInfo = z.infer<typeof clientBasicInfoSchema>;
export type ClientTaxInfo = z.infer<typeof clientTaxInfoSchema>;
